import * as React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { UpdateAdvisorRequest } from '../../../Domain/Shared'
import { RootState, SharedActions } from '../../../Store'

interface IUseProjetoArgs {
  projetoId: string
  perfil: string
}

export const useProjetoId = ({ projetoId, perfil }: IUseProjetoArgs) => {
  if (projetoId === undefined) throw 'Erro: "Id do Projeto" é obrigatório'
  const dispatch = useDispatch()
  const projeto = useSelector((state: RootState) => state.Shared.projeto)

  const getProjetoApiState = useSelector((state: RootState) => state.Shared.apiStates.updateProjetoAction)

  const getAprovarApiState = useSelector((state: RootState) => state.Shared.apiStates.aprovarProjetoAction)
  const getReprovarApiState = useSelector((state: RootState) => state.Shared.apiStates.reprovarProjetoAction)

  const getEditarApiState = useSelector((state: RootState) => state.Shared.apiStates.editarProjetoAction)

  const getAlterarProfessorApiState = useSelector(
    (state: RootState) => state.Shared.apiStates.alterarProfessorProjetoAction
  )

  React.useEffect(() => {
    updateProjeto(projetoId, perfil)
  }, [getReprovarApiState, getAprovarApiState, getEditarApiState, getAlterarProfessorApiState, projetoId])

  const updateProjeto = (projetoId: string, perfil: string) => {
    dispatch(SharedActions.updateProjetoAction(projetoId, perfil))
  }

  const aprovarProjeto = (status: string, projetoId: string, parecer?: any, perfil?: string) => {
    if (projetoId && status == 'aprovar') dispatch(SharedActions.aprovarProjetoAction(projetoId, parecer, perfil))
    if (projetoId && status == 'reprovar') dispatch(SharedActions.reprovarProjetoAction(projetoId, parecer, perfil))
  }

  const editarProjeto = (projeto: any) => {
    dispatch(SharedActions.editarProjetoAction(projeto))
  }

  const updateAdvisor = (perfil: string | undefined, data: UpdateAdvisorRequest) => {
    dispatch(SharedActions.alterarProfessorProjetoAction(perfil ,data))
  }

  return {
    projeto,
    getProjetoApiState,
    getAprovarApiState,
    getEditarApiState,
    updateProjeto,
    aprovarProjeto,
    editarProjeto,
    getReprovarApiState,
    updateAdvisor,
    getAlterarProfessorApiState,
  }
}
